import React, { FC } from 'react';
import { SelectInput, useTranslate } from 'react-admin';
import { ReferenceInput, BranchSelect } from '~/components/ra';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { Solution } from '~/types';
import { NumberInput } from 'react-admin';
import { Configuration } from '~/api/solutions';
import { ReferenceArrayInput } from 'react-admin';
import { SelectArrayInput } from 'react-admin';

interface OnboardingIndividualFormProps {
  record: Solution;
  keyName: string;
  basePath: string;
  configurationRecord: Configuration;
}
export const OnboardingIndividualForm: FC<OnboardingIndividualFormProps> = ({
  record,
  keyName,
  basePath,
  configurationRecord,
}) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  return (
    <>
      <ReferenceInput
        source={`${keyName}.product`}
        reference='products'
        filter={{ solutionId: record.id }}
        basePath={basePath}
        label={t('defaultProduct')}
        className={classes.inputWidth}
        allowEmpty
      >
        <SelectInput optionText='name' />
      </ReferenceInput>
      <ReferenceInput
        source={`${keyName}.metaProduct`}
        reference='products'
        filter={{ solutionId: record.id }}
        basePath={basePath}
        label={t('defaultMetaProduct')}
        className={classes.inputWidth}
        allowEmpty
      >
        <SelectInput optionText='name' />
      </ReferenceInput>
      {keyName === 'veengu_individual_onboarding_self' && (
        <ReferenceArrayInput
          source={`${keyName}.products`}
          reference='products'
          filter={{ solutionId: record.id }}
          basePath={basePath}
          label={t('defaultProducts')}
          className={classes.inputWidth}
          allowEmpty
        >
          <SelectArrayInput optionText='name' />
        </ReferenceArrayInput>
      )}
      <NumberInput
        source={`${keyName}.referralCodeAttempts`}
        label={t('referralCodeInputAttempts')}
        className={classes.inputWidth}
        min={0}
      />
      <BranchSelect
        record={configurationRecord}
        source={`${keyName}.defaultBranch`}
        label={t('branch')}
        className={classes.inputWidth}
      />
    </>
  );
};
